import { Product, ProductPartial, ProductDesign } from '@inter-ikea-storageone/range';
import store from 'ducks/configureStore';
import { getFilterState } from 'ducks/products';

export const getCurrentColorOnScene = () => {
  const filterState = getFilterState(store.getState());
  /* The color from filter state is undefined if the menu hasn't been opened,
     so default to white in that case. */
  return filterState('sections', 'design')?.design || ProductDesign.WHITE;
};

export const isSelectedColorRequirementFulfilled = (product: Product | ProductPartial) => {
  const currentColorOnScene = getCurrentColorOnScene();

  const productColors = product.meta?.color;

  /* We here assume that interiors of a primary color (anthracite or white) have exactly one
     color in productColors, since they have a matching bracket color, whereas interiors of
     an auxiliary color (oak effect or gray) have two colors, since their brackets have a
     non-matching color (one of the primary colors).
     We want interiors of an auxiliary color to always have a bracket color that matches the
     scene color, whereas this is not strictly required for interiors of a primary color. We
     can, thus, check the length of productColors to enforce the requirement on interiors of
     an auxiliary color, while not enforcing it on interiors of a primary color.
     Another approach might be needed in the future if adding new products for which this
     assumption doesn't hold. */
  if (!productColors || productColors.length === 1) return true;

  const colorRequirementFulfilled = !!productColors.find(
    productColor => currentColorOnScene === productColor
  );

  return colorRequirementFulfilled;
};
